<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>IP地址库</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.ip" @keyup.enter.native="clicksearch" placeholder="请输入IP" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.status" placeholder="请选择状态" class="select"  style="width: 150px;">
              <el-option label="请选择状态" value="-1"></el-option>
              <el-option label="待识别" value="0"></el-option>
              <el-option label="已识别" value="1"></el-option>
              <el-option label="待人工处理" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Ip" label="IP" min-width="5%"></el-table-column>
          <el-table-column prop="Country" label="国家" min-width="5%"></el-table-column>
          <el-table-column prop="Region" label="区域" min-width="5%"></el-table-column>
          <el-table-column prop="Province" label="省" min-width="5%"></el-table-column>
          <el-table-column prop="City" label="市" min-width="5%"></el-table-column>
          <el-table-column prop="Isp" label="ISP" min-width="5%"></el-table-column>
          <el-table-column prop="StatusName" label="状态" min-width="5%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="10%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickEdit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickDiSanFang(scope.row)">第三方</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <el-tab-pane label="修改" name="three" disabled="disabled">
      <IpAddressEdit ref="SubVuethree" v-on:triggerFunc="BackToFirst"></IpAddressEdit>
    </el-tab-pane>

  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import IpAddressEdit from '@/componentsSubVue/IpAddressEdit.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    IpAddressEdit
  },
  name: 'MyIpAddress',
  data () {
    return {
      activeName: 'first',
      // 查询
      keywords: {
        ip: '',
        status: '-1'
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      spid: 0
    }
  },
  mounted () {
    this.apiGetIpAddressNum()
    this.apiGetIpAddressList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetIpAddressNum()
      this.apiGetIpAddressList()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickEdit (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData(row)
      window.open("https://www.ipshudi.com/"+row.Ip+".htm")
    },
    clickDiSanFang(row) {
      console.log(row)
      window.open("https://www.ipshudi.com/"+row.Ip+".htm")
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetIpAddressNum()
      this.apiGetIpAddressList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetIpAddressList()
    },
    apiGetIpAddressNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        ip: that.keywords.ip,
        status: that.keywords.status
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetIpAddressNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetIpAddressList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        ip: that.keywords.ip,
        status: that.keywords.status
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetIpAddressList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}
.select1{
    width: 113px;
    margin-right: 15px;
}
/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
/deep/ .el-table .cell {
  white-space: pre-line;
}
</style>
